'use strict';

var index = require('../../../../../aviary-core/dist/cjs/index.cjs');

var HEADING_ELEMENTS = /*#__PURE__*/ function(HEADING_ELEMENTS) {
    HEADING_ELEMENTS[HEADING_ELEMENTS["h1"] = index.DS5_TYPOGRAPHY_TYPES.h1] = "h1";
    HEADING_ELEMENTS[HEADING_ELEMENTS["h2"] = index.DS5_TYPOGRAPHY_TYPES.h2] = "h2";
    HEADING_ELEMENTS[HEADING_ELEMENTS["h3"] = index.DS5_TYPOGRAPHY_TYPES.h3] = "h3";
    HEADING_ELEMENTS[HEADING_ELEMENTS["h4"] = index.DS5_TYPOGRAPHY_TYPES.h4] = "h4";
    HEADING_ELEMENTS[HEADING_ELEMENTS["h5"] = index.DS5_TYPOGRAPHY_TYPES.h5] = "h5";
    return HEADING_ELEMENTS;
}({});

exports.HEADING_ELEMENTS = HEADING_ELEMENTS;
//# sourceMappingURL=Typography.web.types.cjs.map
